/*
 * Exports
 */
export { default } from './components/DigitalMissingFormatWorkflowView.component';



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/digital-missing-format-workflow-view/index.js